import React, { useState, Suspense } from 'react';
import { Route } from 'react-router-dom';
import Loading from '../../components/common/Loading';
import '../../App.css';
import './mainlayout.css';
/*import '../AppRtl.css';*/
import ApiSideNav from '../../components/common/sideNav/apiSideNav.js';
import Header from '../../components/common/header/header';

const ApiLayout = (props) => {
  const [openSideNav, setOpenSideNav] = useState(false);

  const handleOpen = (flag) => {
    setOpenSideNav(flag);
  };

  const handleCloseSideNav = () => {
    setOpenSideNav(false);
  };

  return (
    <div className="mainLayout">
      <Header apiSideNav={handleOpen} {...props} />
      <div className="mainContainer">
        <div className={openSideNav ? "responsiveSideNav block320 slideInSideNav" : "responsiveSideNav block320"}>
          <ApiSideNav {...props} />
        </div>
        <div className="wrapperLayout mrgnLeft320">
          <div className="fullStretchWrapper">
            <Suspense fallback={<Loading />}>
              <Route exact path={props.path} component={props.component} />
            </Suspense>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApiLayout;
